"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("./time");
var get_or_1 = require("get-or");
var __1 = require("..");
/**
 * PaceType:
 *   pace - time/distance
 *   speed - distance/time
 *   there are cases where a pace doesn't need to be calculated, but we still have the time and distance
 */
var PaceType;
(function (PaceType) {
    PaceType["PACE"] = "pace";
    PaceType["SPEED"] = "speed";
    PaceType["NOTCALCULATED"] = "notcalculated";
})(PaceType = exports.PaceType || (exports.PaceType = {}));
var Pace = /** @class */ (function (_super) {
    __extends(Pace, _super);
    function Pace() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.distance = new __1.Distance();
        _this.time = new time_1.Time();
        _this.paceType = PaceType.SPEED;
        return _this;
    }
    return Pace;
}(get_or_1.Transerializable));
exports.Pace = Pace;
//# sourceMappingURL=pace.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/common/pace.js
 ** module id = 255
 ** module chunks = 0
 **/